import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChangePasswordComponent } from './change-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DirectiveModule } from '@sportlogiq/main/shared/directive/sl-directive.module';
import { SlLoaderComponent } from '../sl-loader/sl-loader.component';
import { SlButtonTypeDirective } from '@sportlogiq/main/shared/directive/sl-button/sl-button.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        DirectiveModule,
        SlLoaderComponent,
        SlButtonTypeDirective,
        MatIconModule,
        ReactiveFormsModule
    ],
    declarations: [ChangePasswordComponent],
    exports: [ChangePasswordComponent],
})
export class ChangePasswordModule {}
